import { collection, getDocs } from "firebase/firestore";
import { db } from "../config/firebase";

export const getDirectories = async () => {
    const ref = collection(db, "directory");

    try {
        const res = await getDocs(ref);

        if (res.empty) {
            throw new Error("No  found with the specified role");
        }

        const fetchQuotes = res.docs.map((e) => {
            return {
                ...e.data(),
                id: e.id,
            };
        });

        return fetchQuotes;
    } catch (error) {
        console.error("Error fetching Quotes:", error);
        throw error;
    }
};